module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1jbE4M/tc-custom/9781446354490.jpg?1726519129318",
      "alt": "This image is the cover for the book Bake Me I'm Yours . . . Whoopie Pies, Bake Me I'm Yours . . ."
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bake Me I'm Yours . . . Whoopie Pies, Bake Me I'm Yours . . .\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Easy-as-pie step-by-step instructions for these beloved baked treats!")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" With simple directions perfect for novice bakers and gorgeous designs that will provide inspiration for the more experienced sugarcrafter, this book includes everything you need to create stunning—and tasty!—baked treats from start to finish with a delicious range of cake and filling recipes."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" You’ll find updates and variations on a classic with roots in Pennsylvania Amish country and New England, as well as stylish presentation cake designs showing how you can display your whoopie pies for special occasions.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jill Collins, Natalie Saville\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jill Collins and Natalie Saville own and run The Great Little Cake Company, founded in 2007. They specialize in using quality ingredients to create unique and eye-catching bespoke cakes and cupcakes. As well as having two of their cakes featured in the Jan 2010 issue of Wedding Cakes magazine, they have also produced a cake for the Wildlife Wedding show, sponsored by Wedding TV. They live in London.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    David & Charles\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0